module.exports = __webpack_public_path__ + "img/image(2).cb05b405.png";